// extracted by mini-css-extract-plugin
export default {"space30":"index_space30_J9xey","col_w1000":"index_col_w1000_UadrK"};